module.exports = __webpack_public_path__ + "img/image2_en.4a10aecd.png";